module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/3ac3d0c4fef656830851d20d43787b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_info.svg
// module id = otLx
// module chunks = 1